export type FundingChoice = 'top_up' | 'arrears' | 'pot_total';

export type PanelSectionId = 'inactive' | 'success' | 'dealer' | 'selection' | 'over_balance' | 'details';

export interface PanelState {
    agreementActive: boolean;
    hasSuccessNotice: boolean;
    overBalance: boolean;
    detailsReady: boolean;
}

export interface DetailsReadiness {
    selectionEmpty: boolean;
    overBalance: boolean;
    fundingChoice: FundingChoice | null;
    recordedTopUpAmount: string | null;
    authorisationReason: string | null;
    hasSubmitReasons: boolean;
}

export function isDetailsReady({ selectionEmpty, overBalance, fundingChoice, recordedTopUpAmount, authorisationReason, hasSubmitReasons }: DetailsReadiness): boolean {
    if (hasSubmitReasons) return true;
    if (selectionEmpty) return false;
    if (!overBalance) return true;
    if (fundingChoice === 'top_up') return recordedTopUpAmount !== null;
    if (fundingChoice === 'arrears' || fundingChoice === 'pot_total') return authorisationReason === null;
    return false;
}

export function panelSections({ agreementActive, hasSuccessNotice, overBalance, detailsReady }: PanelState): PanelSectionId[] {
    const sections: PanelSectionId[] = [];
    if (!agreementActive) sections.push('inactive');
    if (hasSuccessNotice) sections.push('success');
    sections.push('dealer', 'selection');
    if (overBalance) sections.push('over_balance');
    if (detailsReady) sections.push('details');
    return sections;
}

export const submitButtonVariant = (choice: FundingChoice | null, overBalance: boolean): 'primary' | 'outline' =>
    overBalance && choice === 'top_up' ? 'outline' : 'primary';
